import { ActivityLogFeed } from "@/app/ActivityLogs/Components/ActivityLogFeed";
import { RecordScreenCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenCard";
import { useOrganisationRecord } from "@/app/Organisations/Hooks/useOrganisationRecord";
import { ModelType } from "@/gql/graphql";

export function OrganisationActivityScreen() {
  const record = useOrganisationRecord();

  return (
    <div className="py-6">
      <RecordScreenCard title="Activity">
        <ActivityLogFeed modelId={record.id} modelType={ModelType.Tenant} />
      </RecordScreenCard>
    </div>
  );
}
